import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable, map, catchError, of } from 'rxjs';

import { EnvironmentConfig } from '../config/environment.config';
import { QuotaSummary } from '../models/quotas/quota-summary.model';
import { Quota } from '../models/quotas/quota.model';

@Injectable({
  providedIn: 'root'
})
export class QuotasService {
  constructor(
    @Inject('environment') private environment: EnvironmentConfig,
    private http: HttpClient
  ) {}

  getQuotas(projectId: string, methodId: string): Observable<Quota[]> {
    return this.http.get<Quota[]>(`${this.environment.endPoint}project/${projectId}/research/${methodId}/quotas`).pipe(catchError(() => of(null)));
  }

  getQuotaSummary(projectId: string, methodId: string): Observable<QuotaSummary[]> {
    return this.http.get<QuotaSummary[]>(`${this.environment.surveyEndPoint}analytics/quotas/${projectId}/${methodId}`).pipe(catchError(() => of([])));
  }

  addQuota(projectId: string, methodId: string, quota: Quota): Observable<Quota> {
    return this.http.post<Quota>(`${this.environment.endPoint}project/${projectId}/research/${methodId}/quota`, quota).pipe(catchError(() => of(null)));
  }

  editQuota(projectId: string, methodId: string, quota: Quota): Observable<Quota> {
    return this.http.put<Quota>(`${this.environment.endPoint}project/${projectId}/research/${methodId}/quotas`, quota).pipe(catchError(() => of(null)));
  }

  deleteQuota(projectId: string, methodId: string, quotaId: string): Observable<boolean> {
    return this.http.delete(`${this.environment.endPoint}project/${projectId}/research/${methodId}/quotas/${quotaId}`).pipe(
      map(() => true),
      catchError(() => of(false))
    );
  }
}
